import { autoinject, bindable } from 'aurelia-framework';
import { PubSub } from 'lib/event/PubSub';
import { AsyncErrorHandler, DialogHandler } from 'lib/ui';
import { ToastService } from 'services';
import { MooringProductionOrderService } from 'services/mooring';
import { HourListDialog } from '../hours/hour-list-dialog';
import { MooringProductionTaskType } from 'models/mooring';

@autoinject
export class DeliveryContainer {
  @bindable productionOrderId: number;

  constructor(
    private productionOrderService: MooringProductionOrderService,
    private toast: ToastService,
    private pubsub: PubSub,
    private dialog: DialogHandler
  ) {}

  protected attached() {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }
  }

  @AsyncErrorHandler
  protected onSave({ canNavigateOnSave }: { canNavigateOnSave: boolean }) {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }

    this.toast.showUpdated();
    this.pubsub.publish('tabs:change-guard-ok', null);
  }

  protected async openHoursDialog() {
    await this.dialog.open(HourListDialog, {
      productionOrderId: this.productionOrderId,
      taskOptions: [MooringProductionTaskType.Packaging],
    });
  }
}
